import React, { useState, useEffect } from "react";
import parse from "html-react-parser";
import "./WaterNoticePopup.css";

const WaterNoticePopup = ({ enabled, title, message }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!enabled) return;
    const timer = setTimeout(() => setShow(true), 1000);
    return () => clearTimeout(timer);
  }, [enabled]);

  useEffect(() => {
    if (show) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => { document.body.style.overflow = ""; };
  }, [show]);

  if (!show) return null;

  return (
    <div className="water-notice-overlay">
      <div className="water-notice-modal">
        <button className="water-notice-x" onClick={() => setShow(false)} aria-label="Close">×</button>
        {/* <div className="water-notice-icon">💧</div> */}
        <h2 className="water-notice-title">{parse(title || "")}</h2>
        <p className="water-notice-message">{parse(message || "")}</p>
       </div>
    </div>
  );
};

export default WaterNoticePopup;
